import React from "react";
import MainTemplate from "../../components/MainTemplate/MainTemplate";
import CardBackground from "../../components/MainTemplate/CardBackground";
import EventCalenderChild from "./EventCalenderChild";

const EventCalender = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <EventCalenderChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default EventCalender;
